<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false"></top-navbar>
  </keep-alive>
  <section class="container-content orders-container-content">
    <transition name="fade">
      <section v-if="!isReady" class="absolute-center-block">
        <div class="container-loading">
          <span class="loader loader-default loader-dark"></span>
        </div>
      </section>
    </transition>

    <transition name="fade">
      <section v-if="isReady" class="container-table">

        <table-component
          :currUserID="currUserID"
          :allHeaders="allHeaders"
          :headersDefault="headersDefault"
          :dataObject="data"
          :defaultData="defaultData"
          :type="typePage"
          :showLeftColumn="false"
          @sort-table="selectSortField"
        ></table-component>

      </section>
    </transition>
  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import TableComponent from "../components/TableComponent.vue";
// import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'PricePage',
  components: {
    TopNavbar,
    TableComponent
  },
  data() {
    return {
      typePage: 'price',
      isReady: false,
      headersDefault: {
        // id: "ID", 
        // startDate: "Дата ПЛ", 
        // division: "Тип продукции", 
        // region: "Регион доставки",
        name: "Название",
        fileRef: "Файл"
      },
      allHeaders: {
        // id: "ID", 
        // startDate: "Дата ПЛ", 
        // division: "Тип продукции", 
        // region: "Регион доставки",
        name: "Название",
        fileRef: "Файл"
      },
      data: [],
      defaultData: [],
      currUserID: "",
    }
  },
  mounted() {
    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.currUserID = localStorage.getItem('userID')
    }

    console.log(this.$route)
    this.init();
  },
  watch: {
    activeTab() {
      this.init()
    }
  },
  methods: {

    // Инициализация
    async init() {
      this.isReady = false
      await this.getData()

      // клон
      this.defaultData = JSON.parse(JSON.stringify(this.data))
      this.isReady = true
    },

    async getData() {

      try {
        const response = await fetch('/price-lists.json', {
          cache: 'no-store',
        })

        if (!response.ok) {
          throw new Error(`Не удалось загрузить price-lists.json: ${response.status}`)
        }

        this.data = await response.json()
      } catch (error) {
        console.error(error)

        this.data = [
          {
            name: "Прайс-лист на строительную изоляцию",
            fileRef: "",
          },
          {
            name: "Прайс-лист на техническую изоляцию",
            fileRef: "",
          },
        ]
      }

      // this.data = [
      //   {
      //     name: "Прайс-лист на строительную изоляцию",
      //     fileRef: process.env.VUE_APP_PRICE_BI,
      //   },
      //   {
      //     name: "Прайс-лист на техническую изоляцию",
      //     fileRef: process.env.VUE_APP_PRICE_TI,
      //   },
      // ]
    },

    // Выбор поля для сортировки
    selectSortField(newDataObj) {
      this.data = newDataObj
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    // Открыть
    openPL(id) {
      this.$router.push({
        path: '/price/detail',
        query: { id: id},
      });
    },

  }
}
</script>
